import Container from '@/components/base/Container';
import SectionLabel from '@/components/base/SectionLabel';
import Reveal from '@/components/base/Reveal';
import InquiryForm from '@/components/feature/InquiryForm';

export default function ContactSection() {
  return (
    <section id="contact" className="relative overflow-hidden border-t border-background-200 bg-white py-20 md:py-28 lg:py-32">
      <span aria-hidden="true" className="pointer-events-none absolute -left-6 top-24 hidden select-none font-poster text-[300px] font-extrabold leading-[0.8] text-primary-500/90 mix-blend-multiply lg:block">A</span>
      <Container className="relative">
        <SectionLabel index="06" label="Let's Talk" />
        <div className="mt-12 grid grid-cols-1 gap-12 md:mt-16 lg:grid-cols-12 lg:gap-6">
          <Reveal className="lg:col-span-5 lg:col-start-1 lg:pl-0 xl:pl-24">
            <h2 className="font-heading text-[44px] font-light leading-[1.02] tracking-[-0.025em] md:text-[64px]">
              Start with a conversation<span className="text-primary-500">.</span>
            </h2>
            <p className="mt-8 max-w-sm text-[15px] leading-[1.7] text-foreground-700 md:text-base">
              Tell us a little about your situation. A partner will read every inquiry and reply personally to arrange an initial, no-obligation conversation.
            </p>
          </Reveal>
          <Reveal delay={120} className="lg:col-span-6 lg:col-start-7">
            <InquiryForm id="home-inquiry" />
          </Reveal>
        </div>
      </Container>
    </section>
  );
}